import * as Types from '../../generated';

import { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
const defaultOptions =  {"context":{"operationName":"OpenCards"}}
export type OpenCardsQueryVariables = Types.Exact<{
  boardId: Types.Scalars['ID'];
}>;


export type OpenCardsQuery = (
  { __typename: 'Query' }
  & { board?: Types.Maybe<(
    { __typename: 'Board' }
    & Pick<Types.Board, 'id'>
    & { cards: Array<(
      { __typename: 'Card' }
      & Pick<Types.Card, 'id' | 'closed'>
    )> }
  )> }
);


export const OpenCardsDocument: DocumentNode = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OpenCards"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"boardId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"board"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"boardId"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"cards"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"EnumValue","value":"open"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"closed"}}]}}]}}]}}]};

/**
 * __useOpenCardsQuery__
 *
 * To run a query within a React component, call `useOpenCardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOpenCardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOpenCardsQuery({
 *   variables: {
 *      boardId: // value for 'boardId'
 *   },
 * });
 */
export function useOpenCardsQuery(baseOptions: Apollo.QueryHookOptions<OpenCardsQuery, OpenCardsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OpenCardsQuery, OpenCardsQueryVariables>(OpenCardsDocument, options);
      }
export function useOpenCardsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OpenCardsQuery, OpenCardsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OpenCardsQuery, OpenCardsQueryVariables>(OpenCardsDocument, options);
        }
export type OpenCardsQueryHookResult = ReturnType<typeof useOpenCardsQuery>;
export type OpenCardsLazyQueryHookResult = ReturnType<typeof useOpenCardsLazyQuery>;
export type OpenCardsQueryResult = Apollo.QueryResult<OpenCardsQuery, OpenCardsQueryVariables>;